<template>
  <v-container>
    <v-card>
      <v-card-title primary-title>
        <h3 class="display-1">
          Dato bruto
        </h3>
      </v-card-title>
      <v-card-text>
        <v-text-field
          id="id"
          v-model="table.search"
          name="search"
          solo
          label="Buscar"
          append-icon="fa fa-search"
        />
        <v-data-table
          v-model="selected"
          :headers="table.headers"
          :items="table.items"
          :search="table.search"
          :loading="table.loading"
          class="elevation-1"
          show-select
          item-key="id"
        >
          <template v-slot:item.actions="props">
            <td>
              <v-btn
                text
                color="info"
                small
                fab
                @click="edit(props.item)"
              >
                <v-icon>fa fa-eye</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="success"
          @click="create()"
        >
          Agregar nuevo Dato bruto
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="modal.active"
      scrollable
      :overlay="false"
      persistent
      max-width="900px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          <h4 class="headline">
            {{ modal.title }}
          </h4>
        </v-card-title>
        <v-card-text>
          <SteperDownload
            :task-data="modal.data"
            :step="modal.step"
            @closeModal="actualiceData"
            @endStore="actualiceData"
          />
        </v-card-text>
        <v-card-actions v-if="modal.step == 2">
          <v-btn
            color="success"
            @click="modal.active = false"
          >
            Ejecutar en segundo plano
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="alert.active"
    >
      {{ alert.messague }}
      <v-btn
        text
        :color="alert.color"
        @click.native="alert.active = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import SteperDownload from './SteperDownload'
export default {
  components: {
    SteperDownload
  },
  props: [
    'auth'
  ],
  data () {
    return {
      createCategory: '',
      editCategory: '',
      baseRoute: process.env.VUE_APP_URL + 'api/gis/',
      table: {
        items: [],
        headers: [],
        loading: true,
        search: ''
      },
      modal: {
        active: false,
        data: {},
        step: 1
      },
      alert: {
        active: false,
        messague: '',
        color: 'success'
      },
      selects: [],
      selected: [],
      response: ''
    }
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      axios.get(this.baseRoute + 'dataRaw').then((res) => {
        if (res.data == 'Error') {
          this.alert.active = true
          this.alert.messague = 'Impsoble traer los datos'
          this.alert.color = 'error'
        } else {
          this.table.items = res.data.items
          this.table.headers = res.data.headers
          this.selects = res.data.selects
        }
        this.table.loading = false
      }).catch(() => {
        this.table.loading = false
        this.alert.active = true
        this.alert.messague = 'Hubó un error interno en el servidor contacte con el desarrollador'
        this.alert.color = 'error'
      })
    },
    create () {
      this.modal.active = true
      this.modal.data = {}
      this.modal.step = 1
      this.modal.title = 'Registrar nueva tarea de descarga'
    },
    store () {
      axios.post(this.baseRoute + '/store', this.modal.data).then((res) => {
        if (res.data != 'Exito') {
          this.alert.active = true
          this.alert.messague = 'Los datos suministrados estan incompletos o no son validos'
          this.alert.color = 'error'
        } else {
          this.alert.active = true
          this.alert.messague = 'Creado exitosamente'
          this.alert.color = 'success'
          this.getData()
        }
      }).catch(() => {
        this.alert.active = true
        this.alert.messague = 'Hubó un error interno en el servidor contacte con el desarrollador'
        this.alert.color = 'error'
      })
    },
    edit (item) {
      this.modal.active = true
      this.modal.data = item
      this.modal.step = 2
      this.modal.title = 'Estado de la descarga'
    },
    update () {
      axios.put(this.baseRoute + '/update', this.modalEdit.data).then((res) => {
        if (res.data != 'Exito') {
          this.alert.active = true
          this.alert.messague = 'Los datos suministrados estan incompletos o no son validos'
          this.alert.color = 'error'
        } else {
          this.alert.active = true
          this.alert.messague = 'Actualizado correctamente'
          this.alert.color = 'success'
          this.getData()
        }
      }).catch(() => {
        this.alert.active = true
        this.alert.messague = 'Hubó un error interno en el servidor contacte con el desarrollador'
        this.alert.color = 'error'
      })
    },
    actualiceData () {
      this.getData()
      this.modal.active = false
    }
  }
}
</script>
